import { useEffect } from "react";

const SRC = "https://admin.kryvocrm.com/kryvo-capture.js";
const TOKEN = "fa78b99ab83141bb09cca041929e8ad0b021";
const ENDPOINT = "https://yzbdrrqfcjqjsciujsig.supabase.co/functions/v1/lead-capture-ingest";
const MOUNT_ID = "kryvo-form-fa78b9";

const injectScript = () => {
  // guarantee a single script tag and a single rendered form
  document.querySelectorAll(`script[src="${SRC}"]`).forEach((s) => s.remove());
  const s = document.createElement("script");
  s.src = SRC;
  s.defer = true;
  s.dataset.kryvoToken = TOKEN;
  s.dataset.kryvoEndpoint = ENDPOINT;
  document.body.appendChild(s);
};

const KryvoCaptureForm = () => {
  useEffect(() => {
    const alreadyLoaded = !!document.querySelector(`script[src="${SRC}"]`);
    if (!alreadyLoaded) {
      injectScript();
      return;
    }
    // Navigated back via client-side routing: only re-run the mount if the form is gone
    const timer = setTimeout(() => {
      const mount = document.getElementById(MOUNT_ID);
      if (mount && !mount.querySelector("iframe")) injectScript();
    }, 400);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div
      className="rounded-2xl border border-kryvo-line bg-white p-6 shadow-[0_20px_60px_-30px_rgba(6,78,42,0.3)] sm:p-8"
      data-testid="kryvo-capture-form"
    >
      <div id={MOUNT_ID} />
    </div>
  );
};

export default KryvoCaptureForm;
